<script setup lang="ts">
const props = defineProps({
  title: String,
  isEmpty: {
    type: Boolean,
    default: false,
  },
  isSearchEmpty: {
    type: Boolean,
    default: false,
  },
  firstLoading: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div class="page flex flex-col">
    <div class="page__body flex flex-col" v-if="!firstLoading">
      <div class="flex justify-between items-start gap-xlarge" v-if="!isEmpty || isSearchEmpty">
        <div class="text-body-tertiary content-neutral-medium">
          <slot name="status"></slot>
        </div>
        <!-- A screen with two actions would otherwise butt them together. -->
        <div class="flex items-center gap-small">
          <slot name="actions"></slot>
        </div>
      </div>

      <div class="page__filter flex gap-small items-center" v-if="!isEmpty || isSearchEmpty">
        <div class="page__filter-left flex gap-small flex-wrap flex-1">
          <slot name="filter-left"></slot>
        </div>
        <div class="page__filter-right flex gap-small justify-end flex-1">
          <slot name="filter-right"></slot>
        </div>
      </div>

      <div class="overflow-x-auto">
        <slot v-if="isSearchEmpty" name="search-empty"></slot>
        <slot v-else-if="isEmpty" name="empty"></slot>
        <slot v-else></slot>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.page {
  gap: token("gap-medium");
  padding: token("padding-xsmall") 0 token("padding-medium");

  @include up("md") {
    padding: token("padding-xsmall") 0 token("padding-large");
  }

  @include up("lg") {
    padding: token("padding-xsmall") 0 token("padding-2xlarge");
  }

  @include up("xl") {
    gap: token("gap-xlarge");
    padding: token("padding-xsmall") 0 token("padding-3xlarge");
  }
}

.page__body {
  padding: token("padding-xlarge");
  border-radius: token("corner-radius-small");
  background: token("color-bg-surface");
  gap: token("gap-medium");

  @include down("md") {
    gap: token("gap-small");
    padding: token("padding-large");
  }

  @include down("sm") {
    gap: token("gap-xsmall");
    padding: token("padding-medium");
  }
}

.page__filter {
  @include down("md") {
    flex-direction: column;
    align-items: stretch;
  }
}

.page__filter-left {
  @include down("md") {
    width: 100%;
  }
}

.page__filter-right {
  @include down("md") {
    width: 100%;
  }
}
</style>
